import React from "react";
import AdminSpinner from "./adminSpinner";

export type AdminButtonVariant = "primary" | "secondary" | "ghost" | "danger" | "success";

const variants: { [key in AdminButtonVariant]: string } = {
    primary: "bg-gray-900 text-white hover:bg-gray-700 active:bg-black disabled:bg-gray-300 disabled:text-gray-500",
    secondary: "bg-white text-gray-800 border border-gray-300 hover:bg-gray-50 hover:border-gray-400 active:bg-gray-100 disabled:text-gray-400 disabled:bg-gray-50 disabled:border-gray-200",
    ghost: "bg-transparent text-gray-700 hover:bg-gray-100 active:bg-gray-200 disabled:text-gray-400 disabled:bg-transparent",
    danger: "bg-red-600 text-white hover:bg-red-700 active:bg-red-800 disabled:bg-red-200 disabled:text-white",
    success: "bg-emerald-600 text-white hover:bg-emerald-700 active:bg-emerald-800 disabled:bg-emerald-200 disabled:text-white",
}

const sizes = {
    sm: "h-8 px-3 text-xs gap-1.5",
    md: "h-10 px-4 text-sm gap-2",
}

export default function AdminButton({
    onClick,
    children,
    disabled = false,
    loading = false,
    variant = "primary",
    size = "md",
    type = "button",
    icon,
    fullWidth = false,
    className = "",
    title,
    form
}: {
    onClick?: () => void;
    children?: React.ReactNode;
    disabled?: boolean;
    loading?: boolean;
    variant?: AdminButtonVariant;
    size?: "sm" | "md";
    type?: "button" | "submit";
    icon?: React.ReactNode;
    fullWidth?: boolean;
    className?: string;
    title?: string;
    // id do <form> que o botão envia (para botões de envio no rodapé do modal, fora do form)
    form?: string;
}) {

    return (
        <button
            type={type}
            form={form}
            onClick={onClick}
            disabled={disabled || loading}
            title={title}
            className={`inline-flex items-center justify-center shrink-0 rounded-lg font-semibold whitespace-nowrap transition-colors select-none disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-secondary focus-visible:ring-offset-2 ${variants[variant]} ${sizes[size]} ${fullWidth ? "w-full" : ""} ${className}`}
        >
            {
                loading ?
                    <AdminSpinner size="sm" />
                    : icon
            }
            {children}
        </button>
    )
}
